module.exports = __webpack_public_path__ + "img/SKMJ_gas1.af055dc4.jpg";